export default __webpack_public_path__ + "static/media/SpendOnlineBackButton.85984b0f.svg";